/*
 *   File : learning-resources.js
 *   Author : https://evoqins.com
 *   Description : Manage-resources page
 *   Integrations : react-toastify,js-cookie
 *   Version : 1.0.0
*/

import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Modal } from "bootstrap";
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';

// Custom components
import { PrimaryButton, TextButton } from '../../../Component/Buttons';
import { CustomSelectBox } from '../../../Component/FormElements';
import { FlashQuizCard, QuizCard, ResourceCard, VideoCard } from '../../../Component/Cards';
import { APIService } from '../../../Service';
import { Pagination } from '../../../Component/pagination';
import { ConfirmationModal, ConfirmDeleteModal, FlashQuizDetailModal, VideoDetailModal } from '../../../Component/Modal';
import { Loader } from '../../../Component/Others';
import { EmptyScreen } from "../../../Component/EmptyComponent";

const CATEGORY_TAB = [
    {
        id: 1,
        name: "Resources"
    },
    // {
    //     id: 2,
    //     name: "Videos"
    // },
    // {
    //     id: 3,
    //     name: "Flash quiz"
    // },
    // {
    //     id: 4,
    //     name: "Quiz"
    // },
];

const CATEGORY = [
    {
        value: 0,
        label: 'All',
    },
    {
        value: 1,
        label: 'Products'
    },
    {
        value: 2,
        label: 'Skills & Services'
    },
];

const ITEMS_PER_PAGE = 16;

const LearningResources = () => {

    const navigate = useNavigate();
    const { state } = useLocation();

    const [adminType, setAdminType] = useState(Cookies.get("admin_type") === "1" ? "super_admin" : "country_admin");
    const [tabIndex, setTabIndex] = useState(0);
    const [toggleFilterCourse, setToggleFilterCourse] = useState(false);
    const [toggleFilterVideo, setToggleFilterVideo] = useState(false);
    const [toggleFilterFlashQuiz, setToggleFilterFlashQuiz] = useState(false);


    const [selected, setSelected] = useState(null);
    const [selectedDuration, setSelectedDuration] = useState(null);

    const [resourceData, setResourceData] = useState({});
    const [loading, setLoading] = useState(true);

    const [totalPageCount, setTotalPageCount] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);

    const [flashQuizDetailData, setFlashQuizDetailData] = useState({});
    const [flashQuizId, setFlashQuizId] = useState(null);
    const [flashQuizDeleteResponse, setFlashQuizDeleteResponse] = useState(false);
    const [flashQuizLoading, setFlashQuizLoading] = useState(true);

    const [deleteStatus, setDeleteStatus] = useState(null);

    const [videoId, setVideoId] = useState(null);
    const [videoDetailData, setVideoDetailData] = useState({});
    const [videoDataLoading, setVideoDataLoading] = useState(true);
    const [videoDeleteResponse, setVideoDeleteResponse] = useState(false);

    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState({});
    const [countrySelect, setCountrySelect] = useState(false);

    const [clearFilter, setClearFilter] = useState(false);

    const [confirmDisable, setConfirmDisable] = useState(false);

    const [courseId, setCourseId] = useState(null);
    const [isEnable, setIsEnable] = useState(false);

    const [disableStatus, setDisableStatus] = useState(false);
    const [buttonLoader, setButtonLoader] = useState(false);

    const [filterData, setFilterData] = useState({});


    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth' //scroll top
        });

        if (adminType === "super_admin") {
            _getCountries();
        }
    }, [adminType]);

    useEffect(() => {
        _getFilterData();
    }, []);

    useEffect(() => {
        const opened_modal = document.querySelector('.modal.show');
        if (opened_modal) {
            const modal = Modal.getInstance(opened_modal);
            modal.hide();

            setFlashQuizId(null);
            setVideoId(null);
        }
    }, [state]);

    useEffect(() => {
        if (state !== null) {
            setTabIndex(state);
        } else {
            setTabIndex(1);
        }
    }, [state]);

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
        if (tabIndex !== 0) {
            _getResourceList();
        }
    }, [tabIndex, currentPage, clearFilter]);

    useEffect(() => {
        if (videoId !== null) {
            _getVideoDetail();

            const detail_modal = new Modal(document.getElementById('video-detail-modal'));
            detail_modal.show();
        }
    }, [videoId]);

    useEffect(() => {
        if (flashQuizId !== null) {
            _getFlashQuizDetail();

            const detail_modal = new Modal(document.getElementById('flash-quiz-detail-modal'));
            detail_modal.show();
        }
    }, [flashQuizId]);


    useEffect(() => {
        if (deleteStatus !== null) {
            const delete_modal = new Modal(document.getElementById('confirm-delete-modal'));
            delete_modal.show();
        }
    }, [deleteStatus]);

    useEffect(() => {
        if (confirmDisable === true) {
            const modal = new Modal(document.getElementById('confirm-modal'));
            modal.show();
        }
    }, [confirmDisable]);

    useEffect(() => {
        // setSelected(CATEGORY[0]);
        if (countrySelect === true) {
            setSelectedCountry(countries[0]);
        }
    }, [tabIndex]);

    // handle tab change 
    const _handleTabChange = (id) => {
        navigate("/manage-training", {
            state: id
        });
        setLoading(true);
        setCurrentPage(1);
        setToggleFilterCourse(false);
        setToggleFilterVideo(false);
        setToggleFilterFlashQuiz(false);
    };

    // handle toggle filter 
    const _handleToggleFilter = (type) => {
        if (type === "course") {
            setToggleFilterCourse(!toggleFilterCourse);
        } else if (type === "video") {
            setToggleFilterVideo(!toggleFilterVideo);
        } else {
            setToggleFilterFlashQuiz(!toggleFilterFlashQuiz);
        }
    };

    //handle pagination
    const _handlePagination = (new_start_limit) => {
        const selected_page = Math.floor(new_start_limit / ITEMS_PER_PAGE) + 1;
        setCurrentPage(selected_page);
    }

    // handle delete 
    const _handleViewFlashQuizDetail = (id) => {
        setFlashQuizId(id);
        setFlashQuizDeleteResponse(false);
    };

    // handle delete flash quiz
    const _handleDeleteFlashQuiz = (quiz_id) => {
        setDeleteStatus(1);
        setFlashQuizId(quiz_id);
        setFlashQuizDeleteResponse(false);
    };

    // handle view video detail modal 
    const _handleViewVideoDetail = (vide_id) => {
        setVideoId(vide_id);
        setVideoDeleteResponse(false);

    };

    // handle delete video
    const _handleDeleteVideo = (vid_id) => {
        setDeleteStatus(2);
        setVideoId(vid_id);
        setVideoDeleteResponse(false);
    };

    // handle navigate add course
    const _handleManageCourse = () => {
        navigate("manage-course", {
            state: {
                type: "",
                course_id: "",
            }
        });
    };

    // handle manage video 
    const _handleManageVideo = () => {
        navigate('manage-video', {
            state: {
                data: "",
                type: ""
            }
        });
    };

    //handle manage flash quiz
    const _handleManageFlashQuiz = () => {
        navigate('manage-flash-quiz', {
            state: {
                data: "",
                type: ""
            }
        });
    };

    // handle filter category 
    const _handleSelectCategory = (value) => {
        setSelected(value);
    };

    // handle filter country 
    const _handleSelectCountry = (value) => {
        setSelectedCountry(value);
    };

    const _handleClearAll = () => {
        setSelected(filterData.filter_item[0]);
        setSelectedDuration(filterData.duration[0]);
        setSelectedCountry(countries[0]);

        setClearFilter(true);
        setLoading(true);
        setCurrentPage(1);
    };


    // API - Get resource list 
    const _getResourceList = (page_num = currentPage) => {
        let is_post = true;
        let url = adminType === "super_admin" ? 'course/resource/list' : 'CA/resource/list';
        let data = {
            "page_num": page_num,
            "filter_type": tabIndex,
            "filter_item": selected?.value || null,
            "duration": selectedDuration?.value || null,
            "country_id": selectedCountry?.value || null
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setResourceData(response.data);
                setTotalPageCount(Math.ceil(response.data.total_count / ITEMS_PER_PAGE));
            } else {
                setResourceData({ data: [] });
            }
            setLoading(false);
            setClearFilter(false);
        });
    };

    // API - Flash quiz detail
    const _getFlashQuizDetail = () => {
        let is_post = true;
        let url = adminType === "super_admin" ? 'flash-quiz/detail' : 'CA/flash-quiz/detail';
        let data = {
            "quiz_id": flashQuizId
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setFlashQuizDetailData(response.data);
                setFlashQuizLoading(false);
            } else {
            }
        });
    };

    // API - Delete flash quiz 
    const _deleteFlashQuiz = () => {
        let is_post = true;
        let url = adminType === "super_admin" ? 'flash-quiz/delete' : 'CA/flash-quiz/delete';
        let data = {
            "flash_quiz_id": flashQuizId
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setFlashQuizDeleteResponse(true);
            } else {
                setFlashQuizDeleteResponse(false);
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
        });
    };

    // API - Delete video
    const _deleteVideo = () => {
        let is_post = true;
        let url = adminType === "super_admin" ? 'video/delete' : 'CA/video/delete';
        let data = {
            "video_id": videoId
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setVideoDeleteResponse(true);
            } else {
                setVideoDeleteResponse(false);
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
        });
    };

    // API - Video detail
    const _getVideoDetail = () => {
        let is_post = true;
        let url = adminType === "super_admin" ? 'video/detail' : 'CA/video/detail';
        let data = {
            "video_id": videoId
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setVideoDetailData(response.data);
                setVideoDataLoading(false);
            } else {
            }
        });
    };

    // API - Get countries
    const _getCountries = () => {

        const country_options = [];

        let is_post = false;
        let url = 'general/list-countries';
        let data = {};

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {

                country_options.push(
                    {
                        value: null,
                        label: "All"
                    }
                );

                response.data.map((country) => (
                    country_options.push(
                        {
                            value: country.value,
                            label: country.label
                        }
                    )
                ));

                setSelectedCountry(country_options[0]);
                setCountries(country_options);
                setCountrySelect(true);
            } else {
                setCountrySelect(false);
            }
        });
    };

    // API - Enable disable  
    const _toggleEnable = () => {

        setButtonLoader(true);

        let is_post = true;
        let url = adminType === "super_admin" ? 'course/disable' : 'CA/course/disable';
        let data = {
            "course_id": courseId
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {

                setDisableStatus(true);


                setTimeout(() => {
                    setConfirmDisable(false);
                    setCourseId(null);
                    _getResourceList();
                    setLoading(true);
                    setIsEnable(false);
                }, 200);


                toast.dismiss();
                toast.success(isEnable ? "Successfully enabled the course" : "Successfully disabled the course", {
                    type: "success",
                    className: "e-toast",
                });
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });

                setDisableStatus(false);
            }

            setButtonLoader(false);
        });
    };


    // API - Filter data
    const _getFilterData = () => {
        let is_post = false;
        let url = adminType === "super_admin" ? 'course/filter-data' : 'CA/resource/filter-data';
        let data = {};

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                const updated_filter_items = response.data.filter_item.map(item => ({
                    value: item.id,
                    label: item.name
                }));

                // const updated_duration = [
                //     { value: null, label: "All" },
                //     ...response.data.duration
                // ];

                setFilterData({
                    ...response.data,
                    filter_item: updated_filter_items,
                    // duration: updated_duration
                });

                setSelected(updated_filter_items[0]);
                setSelectedDuration(response.data.duration[0]);
            } else {
            }
        });
    };


    return (
        <section className='pb-5 '>
            <div className={`${adminType === 'super_admin' ? 'e-bg-azureish-white' : 'e-bg-lavender-blush-light'} padding-12px-top padding-52px-lr`}>
                <h1 className='mb-0 e-primary-font-playfair e-font-24 line-height-32px e-text-raisin-black e-font-weight-600'>
                    Manage Training
                </h1>

                {/* category tab */}
                <div className='d-flex flex-wrap padding-40px-top padding-20px-bottom justify-content-space-between align-items-center'>
                    <div className='d-flex gap-0-16 overflow-auto pb-xl-0 pb-lg-0 pb-md-0 pb-1 e-tab-scroll'>
                        {CATEGORY_TAB.map((data, key) => (
                            <div key={key} className={`${tabIndex === data.id ? 'e-bg-lust e-text-white border-transparent pe-none' : 'e-text-rich-black e-border-1px-cool-grey e-bg-white'} transition e-border-radius-24 cursor-pointer`}
                                onClick={() => _handleTabChange(data.id)} >
                                <p className='mb-0 w-max-content px-4 padding-12px-tb e-alt-font-noto-sans e-font-14 e-font-weight-500 line-height-14px'>
                                    {data.name}
                                </p>
                            </div>
                        ))}
                    </div>

                    {/* Custom buttons */}
                    {tabIndex === 1 ?
                        // add new resource button
                        <div className='pt-xl-0 pt-lg-0 pt-md-0 pt-2'>
                            <PrimaryButton name="Add new resource"
                                className="me-3 e-border-radius-16 padding-14px-tb line-height-12px e-font-16"
                                onPress={_handleManageCourse} />
                            <img src={toggleFilterCourse ? require("../../../Assets/Image/filter-icon-white.svg").default :
                                require("../../../Assets/Image/filter-icon.svg").default}
                                draggable={false}
                                className={`${toggleFilterCourse ? `e-bg-indigo` : ``} transition e-border-1px-cool-gre e-border-radius-8 p-2 cursor-pointer`}
                                alt='filter'
                                onClick={() => _handleToggleFilter("course")} />
                        </div>
                        :
                        // add new video button
                        tabIndex === 2 ?
                            <div className='pt-xl-0 pt-lg-0 pt-md-0 pt-2'>
                                <PrimaryButton name="Add new video"
                                    className="me-3 e-border-radius-16 padding-14px-tb line-height-12px e-font-16"
                                    onPress={_handleManageVideo} />
                                <img src={toggleFilterVideo ? require("../../../Assets/Image/filter-icon-white.svg").default :
                                    require("../../../Assets/Image/filter-icon.svg").default}
                                    draggable={false}
                                    className={`${toggleFilterVideo ? `e-bg-indigo` : ``} transition e-border-1px-cool-grey  e-border-radius-8 p-2 cursor-pointer`}
                                    alt='filter'
                                    onClick={() => _handleToggleFilter("video")} />
                            </div>
                            :
                            // add new flash quiz
                            tabIndex === 3 ?
                                <div className='pt-xl-0 pt-lg-0 pt-md-0 pt-2'>
                                    <PrimaryButton name="Add new flash quiz"
                                        className="me-3 e-border-radius-16 padding-14px-tb line-height-12px e-font-16"
                                        onPress={_handleManageFlashQuiz} />

                                    {countrySelect === true &&
                                        <img src={toggleFilterFlashQuiz ? require("../../../Assets/Image/filter-icon-white.svg").default :
                                            require("../../../Assets/Image/filter-icon.svg").default}
                                            draggable={false}
                                            className={`${toggleFilterFlashQuiz ? `e-bg-indigo` : ``} transition e-border-1px-cool-grey  e-border-radius-8 p-2 cursor-pointer`}
                                            alt='filter'
                                            onClick={() => _handleToggleFilter("flash-quiz")} />
                                    }
                                </div>
                                :
                                tabIndex === 4 ?
                                    <div className='pt-xl-0 pt-lg-0 pt-md-0 pt-2'>
                                        <PrimaryButton name="Add new quiz"
                                            className="me-3 e-border-radius-16 padding-14px-tb line-height-12px e-font-16"
                                            onPress={() => {
                                                navigate("manage-quiz");
                                            }} />
                                    </div>
                                    :
                                    null
                    }
                </div>
            </div>

            <div className='padding-52px-lr'>
                {/* filter */}
                {toggleFilterCourse && tabIndex === 1 ?
                    <div className='e-bg-anti-flash-white-dark py-3 px-4'>
                        <div className='row'>
                            {/* Category  */}
                            <div className=' col-lg-3 col-md-3 col-sm-4 col-6 pe-0'>
                                <CustomSelectBox label="Category"
                                    value={selected}
                                    options={filterData.filter_item}
                                    type={2}
                                    className="e-bg-white e-border-radius-4 e-table-select"
                                    minHeight="34px"
                                    padding="0 8px"
                                    wrapperHeight="0px"
                                    isSearchable={false}
                                    labelClass="e-font-weight-600"
                                    optional={true}
                                    selectChange={(temp) => setSelected(temp)}
                                />
                            </div>
                            <div className=' col-lg-3 col-md-3 col-sm-4 col-6 pe-0'>
                                <CustomSelectBox label="Duration"
                                    value={selectedDuration}
                                    options={filterData.duration}
                                    type={2}
                                    className="e-bg-white e-border-radius-4 e-table-select"
                                    minHeight="34px"
                                    padding="0 8px"
                                    wrapperHeight="0px"
                                    labelClass="e-font-weight-600"
                                    optional={true}
                                    isSearchable={false}
                                    selectChange={(temp) => setSelectedDuration(temp)}
                                />
                            </div>


                            {/* Country select */}
                            {countrySelect === true &&
                                <div className=' col-lg-3 col-md-3 col-sm-4 col-6 pe-0'>
                                    <CustomSelectBox label="Country"
                                        value={selectedCountry}
                                        options={countries}
                                        type={2}
                                        className="e-bg-white e-border-radius-4 e-table-select"
                                        minHeight="34px"
                                        padding="0 8px"
                                        wrapperHeight="0px"
                                        isSearchable={false}
                                        selectChange={(temp) => { _handleSelectCountry(temp); }}
                                    />
                                </div>
                            }

                            <div className='col-md-3 col-sm-4 col-6 mt-auto'>
                                <div className='d-flex gap-3 align-items-center justify-content-end'>
                                    <TextButton name="Clear all"
                                        onPress={_handleClearAll} />
                                    <PrimaryButton name="Filter now"
                                        className="px-3 py-1 e-border-radius-8"
                                        onPress={() => {
                                            _getResourceList(1);
                                            setLoading(true);
                                        }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    // filter video
                    toggleFilterVideo && tabIndex === 2 ?
                        <div className='e-bg-anti-flash-white-dark py-3 px-4'>
                            <div className='row'>
                                <div className='col-xl-2 col-lg-3 col-md-3 col-sm-4 col-8 pe-0'>
                                    <CustomSelectBox label="Category"
                                        value={selected}
                                        options={CATEGORY}
                                        type={2}
                                        className="e-bg-white e-border-radius-8 e-table-select "
                                        labelClass="e-font-weight-600"
                                        isSearchable={false}
                                        selectChange={(temp) => { setSelected(temp); }}
                                    />
                                </div>
                                {/* Country select */}
                                {countrySelect === true &&
                                    <div className='col-xl-2 col-lg-3 col-md-3 col-sm-4 col-8 pe-0'>
                                        <CustomSelectBox label="Country"
                                            value={selectedCountry}
                                            options={countries}
                                            type={2}
                                            className="e-bg-white e-border-radius-8 e-table-select "
                                            labelClass="e-font-weight-600"
                                            isSearchable={false}
                                            selectChange={(temp) => { _handleSelectCountry(temp); }}
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                        :
                        // filter flash quiz
                        toggleFilterFlashQuiz && tabIndex === 3 ?
                            <div className='e-bg-anti-flash-white-dark py-3 px-4'>
                                <div className='row'>
                                    {/* Country select */}
                                    {countrySelect === true &&
                                        <div className='col-xl-2 col-lg-3 col-md-3 col-sm-4 col-8 pe-0'>
                                            <CustomSelectBox label="Country"
                                                value={selectedCountry}
                                                options={countries}
                                                type={2}
                                                className="e-bg-white e-border-radius-8 e-table-select "
                                                labelClass="e-font-weight-600"
                                                isSearchable={false}
                                                selectChange={(temp) => { _handleSelectCountry(temp); }}
                                            />
                                        </div>
                                    }
                                </div>
                            </div>
                            :
                            null
                }

                {loading ?
                    // loader 
                    <Loader />
                    :
                    <>
                        {(Object.keys(resourceData).length !== 0 && resourceData.data.length !== 0) ?
                            <>
                                {/* Resource card */}
                                {tabIndex === 1 ?
                                    <div className='row row-gap-3 pt-4 mt-2 g-3'>
                                        {resourceData.data.map((data, key) => (
                                            <div key={key} className='col-xl-6 col-lg-6 col-md-6 col-12 m-0'>
                                                <ResourceCard course={data}
                                                    handleDisable={() => {
                                                        setConfirmDisable(true);
                                                        setCourseId(data.course_id);
                                                        setIsEnable(data.is_disabled);
                                                    }} />
                                            </div>
                                        ))}
                                    </div>
                                    :
                                    tabIndex === 2 ?
                                        <div className='row row-gap-3 pt-4 mt-2 pb-5'>
                                            {resourceData.data.map((data, key) => (
                                                <div key={key} className='col-xl-6 col-lg-6 col-md-6 col-12'>
                                                    <VideoCard video={data}
                                                        handleView={_handleViewVideoDetail} />
                                                </div>
                                            ))}
                                        </div>
                                        :
                                        // flash quiz card
                                        tabIndex === 3 ?
                                            <div className='row row-gap-3 pt-4 mt-2 pb-5'>
                                                {resourceData.data.map((data, key) => (
                                                    <div key={key} className='col-xl-6 col-lg-6 col-md-6 col-12'>
                                                        <FlashQuizCard flashQuiz={data}
                                                            handleView={_handleViewFlashQuizDetail} />
                                                    </div>
                                                ))}
                                            </div>
                                            :
                                            tabIndex === 4 ?
                                                <div className='row row-gap-3 pt-4 mt-2 pb-5'>
                                                    <div className='col-xl-6 col-lg-6 col-md-6 col-12'>
                                                        <QuizCard data={{}} />
                                                    </div>
                                                </div>
                                                :
                                                null
                                }

                                {/* pagination */}
                                {totalPageCount > 1 &&
                                    <div className="d-flex justify-content-center e-gap-0-16 mt-4 pt-3">
                                        <Pagination itemsPerPage={ITEMS_PER_PAGE}
                                            totalPage={totalPageCount}
                                            showFirstLastPages={true}
                                            onChange={_handlePagination} />
                                    </div>
                                }
                            </>
                            :
                            // empty screen
                            <div className='h-100vh pt-5 mt-5'>
                                <EmptyScreen message="No data found" />
                            </div>

                        }
                    </>
                }

            </div>

            {/* Video detail modal */}
            {videoId !== null &&
                <VideoDetailModal video={videoDetailData}
                    response={videoDeleteResponse}
                    loading={videoDataLoading}
                    handleClose={() => setVideoId(null)}
                    handleDelete={_handleDeleteVideo} />
            }

            {/* flash quiz detail modal */}
            {flashQuizId !== null &&
                <FlashQuizDetailModal flashQuiz={flashQuizDetailData}
                    response={flashQuizDeleteResponse}
                    loading={flashQuizLoading}
                    handleClose={() => setFlashQuizId(null)}
                    handleDelete={_handleDeleteFlashQuiz} />
            }

            {/* confirm delete modal */}
            {deleteStatus !== null &&
                <ConfirmDeleteModal label={deleteStatus === 1 ? "flash quiz" : "video"}
                    deleteId={deleteStatus === 1 ? flashQuizId : videoId}
                    response={deleteStatus === 1 ? flashQuizDeleteResponse : videoDeleteResponse}
                    delete={() => {
                        if (deleteStatus === 1) {
                            _deleteFlashQuiz();
                        } else {
                            _deleteVideo();
                        }
                    }}
                    handleClose={() => setDeleteStatus(null)}
                    success={() => {
                        _getResourceList(1);
                        setFlashQuizDeleteResponse(false);
                        setVideoDeleteResponse(false);
                    }} />
            }

            {confirmDisable === true &&
                <ConfirmationModal title={isEnable ? "Enable course?" : "Disable course?"}
                    description={isEnable ? "This course will be available to learners and can be accessed immediately" : "This course will no longer be available to learners. Existing progress will be retained."}
                    primaryButtonLabel={isEnable ? "Enable" : "Disable"}
                    loader={buttonLoader}
                    status={disableStatus}
                    handleClose={() => {
                        setTimeout(() => {
                            setConfirmDisable(false);
                            setCourseId(null);
                            setDisableStatus(false);
                            setIsEnable(false);
                        }, 200);
                    }}

                    handleSuccess={_toggleEnable}
                />
            }
        </section>
    )
}

export default LearningResources;